import * as api from "@/apiv2/uiInteractions";
import { createAction, createSetterActions } from "@/redux/helpers/action";

import * as selectors from "./company-ui-interactions.selectors";
import { MODULE } from "./constants";

export const [setInteractions] = createSetterActions(MODULE, ["interactions"]);

export const reset = createAction(`${MODULE}/RESET`);

// Log rather than toast: a preference that fails to save is a background
// problem, and the user still gets the behaviour they asked for in this session.
const logFailure = (error) => {
  console.error("Company UI interactions request failed", error);
};

// Tell the backend a user acted on (usually dismissed) a UI element. The endpoint
// replaces the whole map, so merge the new entry over what we already hold and
// send the result. We update the store first so the UI never waits on the network.
//
// The API layer snake_cases request bodies, which leaves the already-snake_case
// keys exactly as they are.
export const recordInteraction = (payload) => async (dispatch, getState) => {
  const interactions = { ...(selectors.getInteractions(getState()) ?? {}), ...payload };
  dispatch(setInteractions(interactions));

  try {
    await api.postUiInteractions({ ui_interactions: interactions })();
  } catch (error) {
    logFailure(error);
  }
};
